import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, switchMap, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { getCustomValues } from '../actions/custom-values.actions';
import { getCustomValuesFailure, getCustomValuesSuccess } from '../actions/custom-values-api.actions';
import { applyCustomValues } from '../reducers/custom-values.reducer';
import { CustomValuesService } from '../../../units/services/custom-values.service';

@Injectable()
export class CustomValuesEffects {

  getCustomValues$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getCustomValues),
      switchMap(action =>
        this._customValuesService.getCustomValues(action.unitIds).pipe(
          exhaustMap(customValues => of(getCustomValuesSuccess({ unitIds: action.unitIds, customValues }))),
          catchError(error => of(getCustomValuesFailure({ error })))
        )
      )
    )
  );

  persistCustomValues$ = createEffect(() =>
    this._actions$.pipe(
      ofType(getCustomValuesSuccess),
      tap(action => {
        try {
          const key = `${environment.storagePrefix}.cachedCustomValues`;
          const raw = localStorage.getItem(key);
          const existing = raw ? JSON.parse(raw) : [];
          localStorage.setItem(key, JSON.stringify(applyCustomValues(existing, action.unitIds, action.customValues)));
        } catch { }
      })
    ), { dispatch: false }
  );

  constructor(
    private _actions$: Actions,
    private _customValuesService: CustomValuesService
  ) { }
}
